import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="vermoegensstruktur-formular"
export default class extends Controller {
	connect() {
		// Action im hidden Field des Datums setzen
		const inputDatum = this.element.querySelector("input[type=hidden][data-datum-target]")
		if (inputDatum) inputDatum.dataset.action = "change->vermoegensstruktur-formular#submit"
	}

	submit() {
		const inputDatum = this.element.querySelector("input[type=hidden][data-datum-target]")

		const [jahr, monat, tag] = inputDatum.value.split("-").map(Number)

		if (jahr < 1900 || monat > 12 || monat < 1) return

		const analysezeitpunkt = new Date(jahr, monat - 1, tag)

		if (isNaN(analysezeitpunkt)) return

		this.element.requestSubmit()
	}
}
